// FILE: src/Components/Organization.js (FULLY UPDATED & SIMPLIFIED)

import React, { useEffect, useRef } from "react";
import CountryDropdown from "../Comman Components/CountryDropdown";
import TimezoneDropdown from "../Comman Components/TimezoneDropdown";
import { Input } from "antd";
import axios from 'axios';

const { TextArea } = Input;

const FormField = ({ label, children }) => (
<div className="mb-5">
<label className="block text-xs font-bold text-gray-500 uppercase mb-2 tracking-wide">{label}</label>
{children}
</div>
);

export default function Organization({
dataOrganization,
onDataChange,
}) {
const didMountRef = useRef(false);

useEffect(() => {
if (didMountRef.current || !onDataChange) return;
didMountRef.current = true;

const detectLocation = async () => {
if (dataOrganization.Brandcountry && dataOrganization.Brandtimezone) return;

const browserTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
let detectedCountry = dataOrganization.Brandcountry;
let detectedTimezone = dataOrganization.Brandtimezone || browserTz;

if (!detectedCountry) {
try {
const response = await axios.get('https://ipwho.is/');
if (response.data.success) {
detectedCountry = response.data.country === "United States" ? "United States of America" : response.data.country;
if (!dataOrganization.Brandtimezone) {
detectedTimezone = response.data.timezone.id;
}
}
} catch (e) {
console.warn("Location detection failed");
}
}

if (detectedCountry !== dataOrganization.Brandcountry || detectedTimezone !== dataOrganization.Brandtimezone) {
onDataChange((prev) => ({
...prev,
Brandcountry: detectedCountry || prev.Brandcountry,
Brandtimezone: detectedTimezone || prev.Brandtimezone,
}));
}
};

detectLocation();
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [dataOrganization, onDataChange]);

const handleInputChange = (e) => {
const { name, value } = e.target;
onDataChange(prev => ({ ...prev, [name]: value }));
};

const handleCountryChange = (selectedCountry) => {
onDataChange(prev => ({ ...prev, Brandcountry: selectedCountry }));
};

const handleTimezoneChange = (selectedTimezone) => {
onDataChange(prev => ({ ...prev, Brandtimezone: selectedTimezone }));
};

return (
<div className="h-full bg-white p-6 rounded-xl border border-gray-200 shadow-sm flex flex-col">
<h3 className="text-lg font-bold text-gray-900 mb-6 pb-2 border-b border-gray-100 flex items-center gap-2">
<i className="fa-solid fa-building text-gray-400"></i> Brand Essentials
</h3>

<div className="space-y-4">
<FormField label="Brand Name">
<Input
name="Brandname"
value={dataOrganization.Brandname || ''}
onChange={handleInputChange}
className="font-bold text-gray-800 text-lg border-gray-300 hover:border-brand-primary focus:border-brand-primary rounded-lg py-2"
placeholder="Enter Brand Name"
/>
</FormField>

<FormField label="Website">
<Input
name="Brandwebsite"
value={dataOrganization.Brandwebsite || ''}
onChange={handleInputChange}
className="text-blue-600 border-gray-300 hover:border-brand-primary focus:border-brand-primary rounded-lg py-2"
placeholder="https://example.com"
prefix={<i className="fa-solid fa-link text-gray-400 mr-2"></i>}
/>
</FormField>

<FormField label="Business Overview">
<TextArea
name="BusinessOverview"
value={dataOrganization.BusinessOverview || ''}
onChange={handleInputChange}
rows={8}
placeholder="Describe what your business does..."
className="text-sm leading-relaxed border-gray-300 hover:border-brand-primary focus:border-brand-primary rounded-lg"
/>
<p className="text-xs text-green-600 mt-2 flex items-center gap-1 font-medium bg-green-50 w-fit px-2 py-1 rounded">
<i className="fa-solid fa-wand-magic-sparkles"></i> AI-Generated & Editable
</p>
</FormField>

<div className="grid grid-cols-1 gap-4 pt-2">
<FormField label="Country">
<CountryDropdown value={dataOrganization.Brandcountry || undefined} onChange={handleCountryChange} />
</FormField>

<FormField label="Time Zone">
<TimezoneDropdown value={dataOrganization.Brandtimezone || undefined} onChange={handleTimezoneChange} />
</FormField>
</div>
</div>
</div>
);
}